import React, {FC} from 'react'
import Badge from '@mui/material/Badge'
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline'
import IconButtonCustom from '@ui/buttons/iconButtonCustom/IconButtonCustom'
import {useChat} from '@containers/chat/ChatProvider'

/**
 * Header chat icon with an unread badge (ported from the legacy GlobalChat badge).
 * Size and colour match the other header icons (26px, white); display:flex on the Badge is
 * required, otherwise inline baseline alignment lifts the icon above its neighbours.
 */
const ChatIconButton: FC = () => {
    const {unreadTotal, openList} = useChat()

    return (
        <IconButtonCustom onClick={openList} tooltip="Чати" variant="empty">
            <Badge
                badgeContent={unreadTotal}
                color="error"
                max={99}
                sx={{
                    display: 'flex',
                    '& .MuiBadge-badge': {
                        fontSize: 10,
                        height: 16,
                        minWidth: 16,
                        padding: '0 4px',
                    },
                }}
            >
                <ChatBubbleOutlineIcon sx={{fontSize: 26, color: '#fff', display: 'block'}}/>
            </Badge>
        </IconButtonCustom>
    )
}

export default ChatIconButton